import { getFieldTitle } from '@src/utils/fieldDefinitionUtils';
import { fixedRateLoanFieldDefinitions } from '@src/utils/OTC/fixedRateLoanFieldDefinitions';
import { formatDayCountConvention, formatPaymentPeriod } from '@src/utils/OTC/otcUtils';
import type { OTCFixedRateLoanProductDetails } from '@talos/kyoko';
import type { ReactNode } from 'react';
import { InspectorText } from '../InspectorText';

type ScheduleSource = Pick<OTCFixedRateLoanProductDetails, 'AccrualPeriod' | 'PaymentPeriod' | 'DayCountConvention'>;

/**
 * Payment Period, Accrual Period, Day Count Convention — appended at bottom of Deal Information for loan products.
 * Payment Period is listed before Accrual Period (Accrual must be ≤ Payment).
 */
export function buildLoanScheduleDealInformationFields(productDetails: ScheduleSource): Array<{
  fieldName: string;
  fieldValue: ReactNode;
}> {
  const accrualLabel = formatPaymentPeriod(productDetails.AccrualPeriod) || '-';
  const paymentLabel = formatPaymentPeriod(productDetails.PaymentPeriod) || '-';
  const dayCountLabel = formatDayCountConvention(productDetails.DayCountConvention) || '-';

  return [
    {
      fieldName: getFieldTitle(fixedRateLoanFieldDefinitions.paymentPeriod),
      fieldValue: <InspectorText>{paymentLabel}</InspectorText>,
    },
    {
      fieldName: getFieldTitle(fixedRateLoanFieldDefinitions.accrualPeriod),
      fieldValue: <InspectorText>{accrualLabel}</InspectorText>,
    },
    {
      fieldName: getFieldTitle(fixedRateLoanFieldDefinitions.dayCountConvention),
      fieldValue: <InspectorText>{dayCountLabel}</InspectorText>,
    },
  ];
}
